import React, { Dispatch } from 'react';
import { Modal } from 'reactstrap';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Formik, FormikActions, FormikProps } from 'formik';
import { ICreateCommentProps } from '../../models/components/create-forum-comment';
import { Log } from 'ng2-logger';
import Quil from '../input/quil/main';
import Translator from '../../core/i18n';
import { answerMessageGetAction } from '../../store/actions/forum';
import { IForumMessage } from '../../models/components/forum-message';
import { getValidation } from '../../models/validations/forum-add-message-validation';
import { Notification, Confirm } from '../../components/notification/main';
import { FileUpload } from '../file-upload/main';
import { Guid } from 'guid-typescript';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';

const T = Translator.create();
const _logger = Log.create('Create or Edit Comment.tsx');
const MAXIMUM_UPLOAD_COUNT = 5;
class CreateComment extends React.Component<ICreateCommentProps, any> {
    _deletedFilesId: string[] = [];
    quillRef: Quil | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            fileUploadKey: 'message_upload_' + this.props.identity.userId + '_' + Guid.create(),
            showFileUploaderCount: 0,
            fileUploaded: false,
            maximumUploadCount: MAXIMUM_UPLOAD_COUNT
        };
    }

    public onSubmit = (values: IForumMessage) => {
        values.deletedFiles = this._deletedFilesId;
        if (this.state.showFileUploaderCount > 0 || values.message.replace(/(<([^>]+)>)/gi, '').length > 0) {
            this.props.dispatch(
                answerMessageGetAction(
                    values.message,
                    values.threadId,
                    values.forumMessageId,
                    this.props.forumSubject!,
                    this.props.messageId ? true : false,
                    this.callback,
                    this.state.fileUploadKey,
                    values.deletedFiles
                )
            );
        } else {
            Notification.setNotification('error', T.t('r_validation_add_forum_message') + ' - ' + T.t('r_field_required'), 'topRight');
        }

        this.resetFileUploder();
    };

    public callback = () => {
        this.props.isClose!();
        this.handleResetText();
    };

    public onClose = () => {
        this.props.isClose!();
    };

    public async beforeClickForm(ikParameter: FormikProps<IForumMessage>) {
        const returnValue = await ikParameter.validateForm().then((returnData: any) => {
            let errorCount = 0;

            Object.keys(returnData).forEach(key => {
                Notification.setNotification('error', T.t('r_validation_add_forum_' + key) + ' - ' + returnData[key], 'topRight');
                errorCount++;
            });
            if (errorCount === 0) {
                if (this.props.messageId) {
                    ikParameter.values.forumMessageId = this.props.messageId;
                }
                ikParameter.submitForm();
            }
        });

        return returnValue;
    }

    public onClickDeleteFile = (fileId: string, fileName: string) => {
        Confirm.setConfirm('normal', () => this.deleteFile(fileId, fileName), T.t('r_delete_file_question'), null);
    };

    public deleteFile = (fileId: string, fileName: string) => {
        this._deletedFilesId.push(fileId);
        this.setState({ maximumUploadCount: this.state.maximumUploadCount + this._deletedFilesId.length });
        const fileDiv = document.getElementById(fileName);
        if (fileDiv) {
            fileDiv.classList.add(...['fadeOut', 'animated', 'hide']);
            setTimeout(() => {
                if (fileDiv.parentNode) fileDiv.parentNode.removeChild(fileDiv);
            }, 1000);
        }
    };

    handleFileModalClose = (uppy: any) => {
        this.props.closeFileUploader!(uppy, 'Edit');
    };

    handleFileUploaded = (uppy: any) => {
        this.props.fileUploadedHandler!(uppy, 'Edit');
        this.fileUploadedHandler(uppy);
    };

    fileUploadedHandler = (uppy: any) => {
        const uploadedCount = Object.keys(uppy.store.state.files).length;
        this.setState({
            fileUploaded: true,
            showFileUploaderCount: uploadedCount,
            maximumUploadCount: this.state.maximumUploadCount - uploadedCount
        });
    };

    resetFileUploder = () => {
        this.props.resetFileUploader!();
        this.setState({ fileUploadKey: 'message_upload_' + this.props.identity.userId + '_' + Guid.create(), fileUploaded: false });
    };

    componentDidUpdate(prevProps: any) {
        if (this.props.commentData) {
            if (this.props.commentData.files !== prevProps.commentData.files) {
                this.checkMaximumUploadCount();
            }
        }
    }

    checkMaximumUploadCount = () => {
        if (this.props.commentData) {
            this.setState({ maximumUploadCount: MAXIMUM_UPLOAD_COUNT - this.props.commentData.files.length });
        }
    };

    onClickShowUploadModal = () => {
        if (this.state.maximumUploadCount <= 0) {
            Notification.setNotification(
                'error',
                T.t('r_forum_maximum_upload_count_error').replace('{0}', MAXIMUM_UPLOAD_COUNT),
                'topRight'
            );
        } else {
            this.props.showFileUploader!('Edit');
        }
    };

    handleResetText() {
        if (this.quillRef) {
            this.quillRef.state.description = "";
        }
    }

    render() {
        const initialValues = { ...this.props.commentData! };
        return (
            <Modal style={{ maxWidth: '570px' }} isOpen={this.props.isOpen} toggle={this.onClose}>
                {(this.props.messageId && initialValues.forumMessageId) || !this.props.messageId ? (
                    <Formik
                        initialValues={{ ...initialValues }}
                        validationSchema={getValidation}
                        onSubmit={this.onSubmit}
                        enableReinitialize={true}
                        render={props => (
                            <form onSubmit={props.handleSubmit}>
                                <div
                                    className="assignment-feedback bulk-grade"
                                    id="forum-reply"
                                    role="dialog"
                                    aria-labelledby="exampleModalLabel"
                                    aria-hidden="true"
                                >
                                    <div role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                                                    {T.t('r_gen_update_message')}
                                                </h6>
                                                <button type="button" className="close" onClick={this.onClose} style={{ margin: "-1rem -1rem -1rem -1rem" }}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <Quil
                                                    ref={ref => { this.quillRef = ref }}
                                                    modules={'basic'}
                                                    placeholder={T.t('r_message_place_holder')}
                                                    // tslint:disable-next-line
                                                    onChange={(e: any) => {
                                                        props.setFieldValue('message', e);
                                                    }}
                                                    className={'custom-quill'}
                                                    value={props.values.message ? props.values.message : ''}
                                                    theme={'snow'}
                                                />

                                                {props.values.files
                                                    ? props.values.files.map((file: any) => {
                                                        return (
                                                            <div
                                                                key={file.fileName}
                                                                id={file.fileName}
                                                                className="row mt-4"
                                                                style={{ paddingLeft: '15px', paddingRight: '15px' }}
                                                            >
                                                                <p>
                                                                    <b>{T.t('r_file')} </b>
                                                                    {file.fileName}
                                                                </p>
                                                                <i
                                                                    onClick={this.onClickDeleteFile.bind(
                                                                        this,
                                                                        file.fileId,
                                                                        file.fileName
                                                                    )}
                                                                    className="material-icons del-icon del-icon-color"
                                                                    style={{ marginLeft: 'auto', cursor: 'pointer' }}
                                                                >
                                                                    delete
                                                                </i>
                                                            </div>
                                                        );
                                                    })
                                                    : ''}
                                            </div>
                                            <div className="modal-footer border-none">
                                                <button
                                                    type="button"
                                                    className="btn btn-gray-outline"
                                                    data-dismiss="modal"
                                                    onClick={this.onClose}
                                                >
                                                    {T.t('r_gen_cancel')}
                                                </button>
                                                <div style={{ display: 'flex' }}>
                                                    {!props.values.whoReplyForumMessageId && (
                                                        <a
                                                            className="input-group-text mr-2"
                                                            style={{
                                                                float: 'left',
                                                                backgroundColor: 'white',
                                                                borderColor: 'white',
                                                                height: 'auto'
                                                            }}
                                                        >
                                                            <i className="material-icons" onClick={this.onClickShowUploadModal}>
                                                                add
                                                            </i>
                                                        </a>
                                                    )}
                                                    {this.state.fileUploaded ? (
                                                        <div style={{ position: 'absolute', right: '205px', bottom: '60px' }}>
                                                            <span
                                                                style={{ height: '16px', color: 'orange', marginLeft: '-10px' }}
                                                                className="badge badge-pill badge-light"
                                                            >
                                                                {this.state.showFileUploaderCount}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    height: '16px',
                                                                    color: 'red',
                                                                    marginLeft: '0px',
                                                                    cursor: 'pointer'
                                                                }}
                                                                title="Dosyayı sil"
                                                                className="badge badge-pill badge-light"
                                                                onClick={this.resetFileUploder}
                                                            >
                                                                x
                                                            </span>
                                                        </div>
                                                    ) : null}
                                                    <button
                                                        type="button"
                                                        onClick={() => this.beforeClickForm(props)}
                                                        className="btn btn-gray"
                                                    >
                                                        <i className="material-icons float-left mt-1 mr-4-forum">send</i>
                                                        <div className="float-right">{T.t('r_gen_update_message')}</div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                ) : (
                    ''
                )}

                {this.props.showFileUploaderState ? (
                    <FileUpload
                        key={this.state.fileUploadKey}
                        fileInputKey={this.state.fileUploadKey}
                        height={250}
                        maxFileSize={10000000}
                        maxSelectedFileCount={this.state.maximumUploadCount}
                        isCardImage={false}
                        isModal={true}
                        modalOpen={this.props.showFileUploaderState}
                        handleModalClose={this.handleFileModalClose}
                        fileTypes={window.appSettings.ForumFileUploadAllowedTypes}
                        triggerFileUpload={this.handleFileUploaded}
                    />
                ) : (
                    ''
                )}
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICreateCommentProps) => {
    if (!state) {
        return ownProps;
    }

    const newProps: ICreateCommentProps = Object.assign({}, ownProps, {
        commentData: state.forum.messageData,
        forumSubject: state.forum.forumMessageSubject,
        identity: state.login.identitiy
    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CCreateComment = connect(mapStateToProps, dispatchProps)(CreateComment);

export default CCreateComment;
